import { Helmet } from "react-helmet-async";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import GenericStyleList from "./GenericStyleList";
import { styleTypes } from "../../enums/styleTypes";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ActionButtons from "../../components/ActionButtons/ActionButtons";

const ListStyleList = () => {
  const [actionContext, setActionContext] = useState({
    actions: [],
    handlers: [],
  });
  const navigate = useNavigate();
  
  return (
    <div className="page-content">
      <Helmet>
        <title>List Styles</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row>
                  <div className="d-flex justify-content-between my-2">
                    <h2>LIST STYLES</h2>
                    <ActionButtons 
                      actions={actionContext.actions}
                      context="list_style"
                      handlers={{
                        create: () => navigate(`/${actionContext.handlers}`),
                      }}
                    />
                  </div>
                </Row>
                <GenericStyleList type={styleTypes.LIST} navigateToCreate={setActionContext}/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListStyleList;
